jQuery(document).ready(function($) {

}) 
